declare global {
  interface Window {
    [RewardVarName]?: {
      (...args: unknown[]): void;
      q?: unknown[][];
    };
  }
}

export const RewardVarName = "rewardPlugin";

export const queue = window[RewardVarName]?.q || [];
